import { Checkbox, ListItemText, MenuItem, TextField, type TextFieldProps } from '@mui/material';
import { type Collective } from 'src/shared/types/collective';

export type CollectivesSelectFieldProps = Omit<TextFieldProps, 'value'> & {
  value: string[];
  collectives: Collective[];
};

export const CollectivesSelectField = ({ collectives, value, ...rest }: CollectivesSelectFieldProps) => {
  const renderSelectedNames = (selected: unknown) =>
    (selected as string[])
      .map(id => collectives.find(collective => collective.id === id)?.name)
      .filter(Boolean)
      .join(', ');

  return (
    <TextField {...rest} value={value} select SelectProps={{ multiple: true, renderValue: renderSelectedNames }}>
      {collectives.map(collective => (
        <MenuItem key={collective.id} value={collective.id}>
          <Checkbox checked={value.includes(collective.id)} />
          <ListItemText primary={collective.name} />
        </MenuItem>
      ))}
    </TextField>
  );
};
